import BackButton from "%/dynamic-component-editor/standard-pages/subscription-failure-page/BackButton.vue";
import LegacyEntity from "%/dynamic-component-editor/classes/LegacyEntity";

export default class LegacySubscriptionFailure extends LegacyEntity {
  get elements() {
    return {
      BackButton,
    };
  }
}
